import { z } from 'zod';
import { requiredString } from '../helpers';
export const Hubspot_Get_Tickets_1_ConfigValidator = z
    .object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    contactEmail: z.string().optional(),
    contactPhoneNumber: z.string().optional(),
    pipelineId: z.string().nullable().optional(),
    additionalProperties: z.string().optional(),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true;
        try {
            JSON.parse(val);
            return true;
        }
        catch {
            return false;
        }
    }, { message: 'Expected output must be valid JSON' })
})
    .refine((data) => {
    const hasEmail = data.contactEmail && data.contactEmail.trim() !== '';
    const hasPhone = data.contactPhoneNumber && data.contactPhoneNumber.trim() !== '';
    return (hasEmail || hasPhone) && !(hasEmail && hasPhone);
}, {
    path: ['contact'],
    message: 'Please fill in either Email or Phone Number'
});
//# sourceMappingURL=hubspot-get-tickets-1.js.map